var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-35 md-small-size-hide"},[_c('main-table',{attrs:{"data":_vm.data,"lease":true}})],1),_c('div',{staticClass:"md-layout-item md-size-65 md-small-size-100"},[_c('tree-map-prod',{attrs:{"data":_vm.data,"pre":"prod"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }